import React, { useMemo, useState } from 'react'
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import { LayersIcon } from '@radix-ui/react-icons'
import ChangeLayerDialog from './ChangeLayerDialog'

const ChangeLayer = ({ cpt, cpts }) => {
  const [open, setOpen] = useState(false)

  const childs = useMemo(
    () => cpts?.filter((c) => c.pid === cpt.id),
    [cpt.id, cpts],
  )

  if (cpt.pid) {
    return (
      <DropdownMenuItem onClick={(e) => e.preventDefault()}>
        <LayersIcon className="w-4 h-4 mr-2" /> Cannot move: linked child
      </DropdownMenuItem>
    )
  }
  if (childs.length > 0) {
    return (
      <DropdownMenuItem onClick={(e) => e.preventDefault()}>
        <LayersIcon className="w-4 h-4 mr-2" /> Cannot move: has linked styles
      </DropdownMenuItem>
    )
  }

  return (
    <>
      <DropdownMenuItem
        onSelect={(e) => {
          e.preventDefault()
          setOpen(true)
        }}
      >
        <LayersIcon className="w-4 h-4 mr-2" />
        Move to layer
      </DropdownMenuItem>
      <ChangeLayerDialog
        open={open}
        onOpenChange={setOpen}
        components={[cpt]}
      />
    </>
  )
}

export default ChangeLayer
